import { useMemo } from "react";
import { decode } from "@/utils/auth";
import { useSession } from "next-auth/react";

export function useDecodedUserIdSession(): string {
  const { data: session } = useSession() as any;

  return useMemo(() => {
    if (!session?.accessToken) return "";
    const decoded = decode(session.accessToken);
    return decoded?.sub ?? "";
  }, [session?.accessToken]);
}
